export default __webpack_public_path__ + "static/assets/med_x_spray_mask.80f8e3e3.png";